import { render } from "./CustomBoardCard.vue?vue&type=template&id=593e488d&scoped=true"
import script from "./CustomBoardCard.vue?vue&type=script&lang=js"
export * from "./CustomBoardCard.vue?vue&type=script&lang=js"

import "./CustomBoardCard.vue?vue&type=style&index=0&id=593e488d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-593e488d"]])

export default __exports__